import { Enum } from 'enumify';

export default class UserType extends Enum {}
UserType.initEnum([
  'USER',
  'TESTER',
]);



// WEBPACK FOOTER //
// ./src/routes/patient/UserType.js